export default "<div class=\"map-container\" #mapContainer></div>\n"